// Static content for the My Brand Online landing page.

const IMG = "https://static.prod-images.emergentagent.com/jobs/bcdd5b45-fa1e-4089-923f-1e1c9bcdae34/images/";

export const media = {
  heroComposition: "https://customer-assets-gfyr7b9c.emergentagent.net/job_select-brandize-ship/artifacts/ffnx3wut_ChatGPT%20Image%203%20set%202026%2C%2016_47_04%20%282%29.png",
  heroModel: "https://customer-assets-gfyr7b9c.emergentagent.net/job_select-brandize-ship/artifacts/r6h5bk0c_ChatGPT%20Image%203%20set%202026%2C%2016_57_28.png",
  editorialModel: "https://images.unsplash.com/photo-1762605135012-56a59a059e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  brandingLabel: IMG + "38eba6b89bc43b290b6da40fd673cd8340dcbe23922050cfccf5ff0a85d2982a.jpeg",
  brandingHangtag: IMG + "c1a7e48ba4e729b684a1ce235ec66624f7e5c94f353021a0f1cc0587ab9ac68f.jpeg",
  brandingPackaging: IMG + "4045f7059534151c73718d8d4ed58129f261f9bb378c61d546447a90da0d0d43.jpeg",
};

export const microBenefits = [
  "Migliaia di prodotti",
  "Zero stock in anticipo",
  "Branding on demand",
  "Fulfillment diretto",
];

export const marqueeItems = [
  "Fashion Infrastructure",
  "Private Label",
  "Branding On Demand",
  "Catalogo Fashion",
  "Fulfillment Europeo",
  "Spedizione Diretta",
  "Zero Stock In Anticipo",
];

const ASSETS = "https://customer-assets-gfyr7b9c.emergentagent.net/job_select-brandize-ship/artifacts/";

export const products = [
  { id: 1, code: "MB204", name: "Abito Fiorella", cat: "Abiti", style: "Cerimonia", isNew: true, badge: "Disponibile per il tuo brand", img: ASSETS + "j3q60cnb_abiti_01.webp" },
  { id: 2, code: "5831", name: "Abito Celeste", cat: "Abiti", style: "Elegante", isNew: false, badge: "Brandizzabile on demand", img: ASSETS + "svqi9clz_abiti_02.webp" },
  { id: 3, code: "77125", name: "Abito Vivienne", cat: "Abiti", style: "Elegante", isNew: true, badge: "Pronto per essere venduto", img: ASSETS + "1pfoum8n_abiti_03.webp" },
  { id: 4, code: "MB318", name: "Top Vanessa", cat: "Top", style: "Elegante", isNew: false, badge: "Disponibile per il tuo brand", img: ASSETS + "jpansh8n_top_01.jpg" },
  { id: 5, code: "4402", name: "Coordinato Sofia", cat: "Coordinati", style: "Elegante", isNew: true, badge: "Brandizzabile on demand", img: ASSETS + "z37z5ta3_coordinati_01.jpg" },
  { id: 6, code: "MB127", name: "Coordinato Camilla", cat: "Coordinati", style: "Casual", isNew: false, badge: "Pronto per essere venduto", img: ASSETS + "fih75qk5_coordinati_02.webp" },
  { id: 7, code: "6090", name: "Pantalone Aura", cat: "Pantaloni", style: "Casual", isNew: false, badge: "Disponibile per il tuo brand", img: ASSETS + "vaj4cd1r_pantaloni_01.jpg" },
  { id: 8, code: "MB552", name: "Jeans Elisa", cat: "Jeans", style: "Casual", isNew: true, badge: "Brandizzabile on demand", img: ASSETS + "82kutg18_Jeans_01.jpg" },
  { id: 9, code: "3217", name: "Maglia Noemi", cat: "Maglieria", style: "Casual", isNew: false, badge: "Pronto per essere venduto", img: ASSETS + "tdrdwcmp_Maglie_01.webp" },
  { id: 10, code: "MB489", name: "Maglia Ginevra", cat: "Maglieria", style: "Casual", isNew: false, badge: "Disponibile per il tuo brand", img: ASSETS + "a5lvdol8_Maglia_02.webp" },
  { id: 11, code: "8064", name: "Tuta Elegante Chloe", cat: "Tute eleganti", style: "Cerimonia", isNew: true, badge: "Brandizzabile on demand", img: ASSETS + "ypuflzm7_Tute_eleganti_01.webp" },
  { id: 12, code: "MB731", name: "Tuta Elegante Serena", cat: "Tute eleganti", style: "Elegante", isNew: false, badge: "Pronto per essere venduto", img: ASSETS + "lzcf4w4n_tute_eleganti_02.webp" },
];

export const styleFilters = ["Tutti gli stili", "Elegante", "Casual", "Cerimonia"];

export const catalogFilters = ["Tutti", "New", "Abiti", "Top", "Coordinati", "Pantaloni", "Jeans", "Maglieria", "Tute eleganti"];

export const categoryTags = [
  "Abiti casual", "Abiti eleganti", "Abiti da cerimonia", "Abiti maglione", "Jumpsuit", "Coordinati",
  "Camicie", "Bluse", "Top", "T-shirt", "Canotte", "Maglieria",
  "Pantaloni", "Jeans", "Gonne", "Shorts", "Leggings",
  "Giacche", "Blazer", "Capispalla",
  "Costumi interi", "Bikini", "Tankini",
  "Calzature", "Stivali", "Stivaletti", "Borse", "Accessori",
];

export const steps = [
  {
    num: "01", key: "SCEGLI",
    title: "Scegli tra migliaia di prodotti",
    body: "Accedi a un catalogo fashion ampio e in continua evoluzione e seleziona soltanto ciò che rappresenta il tuo brand.",
    quote: "Il catalogo è nostro. La selezione diventa tua.",
  },
  {
    num: "02", key: "PUBBLICA",
    title: "Costruisci la tua collezione",
    body: "Seleziona i prodotti che vuoi vendere e importali nel tuo ecommerce con un click. Costruisci una collezione coerente con il tuo stile, il tuo pubblico e il tuo posizionamento, mentre lo stock rimane nell'infrastruttura My Brand Online.",
    quote: "Non devi comprare il prodotto per iniziare a venderlo.",
  },
  {
    num: "03", key: "VENDI",
    title: "Il tuo cliente acquista",
    body: "Tu gestisci ciò che costruisce valore davanti al cliente: brand, marketing, contenuti, community e vendite. Quando ricevi un ordine, inizia il lavoro di My Brand Online.",
    quote: "",
  },
  {
    num: "04", key: "BRANDIZZIAMO",
    title: "Trasformiamo l'ordine nel tuo brand",
    body: "Prendiamo la singola unità venduta e la prepariamo secondo l'identità configurata per la tua attività.",
    list: ["La tua etichetta", "Il tuo cartellino", "Il tuo packaging", "I tuoi elementi di presentazione"],
    quote: "Il prodotto parte dalla nostra infrastruttura. Arriva al cliente come tuo.",
  },
  {
    num: "05", key: "SPEDIAMO",
    title: "Direttamente al cliente finale",
    body: "Prepariamo il pacco e gestiamo il fulfillment e la spedizione. Tu non devi ricevere scatoloni, cercare taglie, preparare pacchi o organizzare il ritiro del corriere.",
    quote: "Per il cliente esiste il tuo brand. Dietro il tuo brand esiste My Brand Online.",
  },
];

export const comparison = {
  traditional: {
    title: "Il modello tradizionale",
    items: [
      "Acquisto anticipato dello stock",
      "Migliaia di euro immobilizzati",
      "Taglie e colori da prevedere",
      "Rimanenze",
      "Magazzino",
      "Picking",
      "Etichettatura",
      "Packaging",
      "Personale",
      "Spedizioni quotidiane",
    ],
  },
  mbo: {
    title: "Con My Brand Online",
    items: [
      "Migliaia di prodotti tra cui scegliere",
      "Nessun capitale immobilizzato in stock.",
      "Costruisci il catalogo più adatto al tuo brand.",
      "Ogni ordine viene preparato con la tua identità.",
      "Picking gestito da MBO",
      "Packaging gestito da MBO",
      "Fulfillment della merce gestito da MBO.",
      "Spedizione diretta al cliente",
    ],
  },
};

export const audiences = [
  { tag: "01", title: "Ecommerce", body: "Aggiungi nuove categorie e nuovi prodotti senza aumentare proporzionalmente il capitale immobilizzato in stock." },
  { tag: "02", title: "Nuovi Brand", body: "Costruisci la tua prima collezione e inizia a venderla senza acquistare stock in anticipo." },
  { tag: "03", title: "Retailer", body: "Porta nel tuo negozio una collezione firmata dal tuo brand e aumenta il valore percepito della tua offerta." },
  { tag: "04", title: "Creator & Influencer", body: "Trasforma la tua community in un brand fashion senza costruire da zero tutta la struttura operativa." },
];

export const faqs = [
  { q: "Devo acquistare stock in anticipo?", a: "No. Non devi acquistare stock per iniziare a vendere. Scegli i prodotti dal catalogo, li pubblichi sul tuo store e, quando ricevi un ordine, My Brand Online prepara la singola unità venduta." },
  { q: "La merce viene spedita prima a me?", a: "No, non necessariamente. Puoi scegliere se far spedire l'ordine direttamente al cliente finale oppure riceverlo tu. Sei tu a decidere come gestire la consegna." },
  { q: "Quando viene applicata l'etichetta del mio brand?", a: "Dopo la vendita. Una volta ricevuto l'ordine, la singola unità viene preparata con gli elementi di branding previsti prima della spedizione." },
  { q: "Posso avere il mio cartellino e il mio packaging?", a: "Sì. Il servizio può prevedere etichette, cartellini, packaging ed elementi personalizzati in base alla configurazione scelta." },
  { q: "Devo vendere tutto il catalogo?", a: "No. Selezioni soltanto i prodotti coerenti con il tuo brand e la tua strategia." },
  { q: "Posso utilizzare My Brand Online se ho già Shopify?", a: "Sì. Il servizio è pensato anche per ecommerce già operativi che vogliono ampliare il catalogo o esternalizzare parte della gestione fisica degli ordini." },
  { q: "Ci sono quantità minime?", a: "Per i prodotti, no. Non devi acquistare quantità minime per iniziare a venderli. Eventuali minimi possono riguardare soltanto la produzione degli elementi personalizzati del tuo brand, come etichette, cartellini o packaging." },
  { q: "Il mio cliente vedrà My Brand Online?", a: "No. My Brand Online lavora dietro le quinte. Il cliente riceve l'ordine con l'identità del tuo brand — etichetta, cartellino e packaging — secondo la configurazione scelta." },
];

export const formOptions = {
  businessType: ["Sì, ecommerce", "Sì, negozio fisico", "Sì, entrambi", "Sto preparando il lancio", "Non ancora"],
  platform: ["Shopify", "WooCommerce", "Marketplace", "Instagram / TikTok", "Negozio fisico", "Altro", "Non vendo ancora"],
  orders: ["Non vendo ancora", "1–25", "26–100", "101–300", "301–1.000", "Oltre 1.000"],
  interests: [
    "Vendere senza acquistare stock",
    "Creare il mio brand",
    "Private label / branding",
    "Ampliare il catalogo",
    "Fulfillment",
    "Spedizione diretta",
    "Tutto il sistema My Brand Online",
  ],
  countries: ["Italia", "España", "France", "Deutschland", "Portugal", "Nederland", "Österreich", "Belgique", "Altro"],
};
